import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class ItemService extends AbstractService {

    addItems(items, accountId) {
        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + 'bo/accounts/' + accountId + '/products',
            json: { items }
        }).then(responseData => {
            if (responseData.ok) {
                return true;
            }
            throw responseData.error();
        });
    }

    diffImportItems(keys, items, accountId) {
        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + 'bo/accounts/' + accountId + '/update-products-diff',
            json: {
                keys,
                item_keys: items
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData.ok;
        });
    }

    execImportItems(keys, values, items, articleRules, attributesRules, accountId) {
        const json = {
            keys,
            values,
            articles: items
        };

        articleRules.forEach(r => json[r.name] = r.value);

        attributesRules.forEach(r => {
            json[r.name] = {};
            r.attributes.forEach(a => json[r.name][a.name] = a.value);
        });

        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + 'bo/accounts/' + accountId + '/update-products-exec',
            json,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData.ok;
        });
    }

    async importAdditionalDatas(items, accountId) {
        return this.request({
            method: 'POST',
            url: Facade.getApiRoot() + `bo/accounts/${accountId}/missing-additional-data`,
            json: items
        }).then( async (responseData) => {
            if (responseData.ok) {
                return await responseData.json();
            }
            throw responseData.ok;
        });
    }
}

export default new ItemService();
